export const PARTY_NAME = "kansassmittys";
